import { SettingsState, SettingsAction, SettingsActionTypes as ActionTypes } from './types';

const initialSettingsState: SettingsState = {
  refresh: {},
  isLoading: false,
  isSubmitting: false,
  settings: null,
};

const settingsReducer = (
  state: SettingsState = initialSettingsState,
  action: SettingsAction,
): SettingsState => {
  switch (action.type) {
    case ActionTypes.INIT:
      return initialSettingsState;

    case ActionTypes.REFRESH:
      return { ...state, refresh: {} };

    case ActionTypes.LOADING:
      return { ...state, isLoading: action.payload };

    case ActionTypes.SUBMITTING:
      return { ...state, isSubmitting: action.payload };

    case ActionTypes.SET_SETTINGS:
      return { ...state, settings: action.payload};

    default:
      return state;
  }
};

export default settingsReducer;
